module.exports = new __parcel__URL__("plastic-beach.5e3cd5bb.jpg").toString();